import axios from 'axios';

import * as utils from '../utils/utils.js';

export const queryAttendance = async (startDate, endDate, events, limit) => {
    var session_url = utils.backendUrl() + '/attendance-stats';

    try {
        const response = await axios.post(
            session_url,
            {
                start_date: startDate,
                end_date: endDate,
                events: events,
                limit: limit,
                headers: {
                    'Content-Type': 'application/json',
                },
            },
            {
                withCredentials: true,
            }
        );

        return response.data.result;
    } catch (err) {
        console.error(err);
        throw err;
    }
};
